import React, { useCallback, useState } from 'react';
import { ButtonGroup, Content, Dialog, DialogContainer, Text, useDialogContainer, } from '@adobe/react-spectrum';
import { ActionButton, Button } from '@react-spectrum/button';
import { Flex } from '@react-spectrum/layout';
import { View } from '@react-spectrum/view';
import Preview from '@spectrum-icons/workflow/Preview';
import { ProjectActions } from 'app/stores/project/actions';
import { useAppDispatch } from 'app/stores/store';
import { noop } from 'app/utils/function';
const PreviewRenderDialog = (props) => {
    const { url } = props;
    const dialog = useDialogContainer();
    return (React.createElement(Dialog, { "data-test-id": "publish-dialog" },
        React.createElement(Content, null,
            React.createElement(Flex, { direction: "column" },
                React.createElement(View, null,
                    React.createElement("img", { src: url, alt: "Preview", style: { maxWidth: '100%' } })))),
        React.createElement(ButtonGroup, null,
            React.createElement(Button, { variant: "accent", onPress: dialog.dismiss }, "Dismiss"))));
};
export const PreviewRender = () => {
    const appDispatch = useAppDispatch();
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(undefined);
    const [previewUrl, setPreviewUrl] = useState(undefined);
    const onPreview = useCallback(() => {
        setBusy(true);
        appDispatch(ProjectActions.rasterizeProject({
            format: 'image/png',
            strategy: 'current_page',
            useSyncRasterizer: true,
        }))
            .unwrap()
            .then(output => {
            setBusy(false);
            const { data } = output[0];
            const url = URL.createObjectURL(data);
            setPreviewUrl(url);
        })
            .catch(err => {
            setError(err.message);
            setBusy(false);
        });
    }, [appDispatch, setBusy, setError, setPreviewUrl]);
    const onDismiss = useCallback(() => {
        setPreviewUrl(url => {
            if (url) {
                URL.revokeObjectURL(url);
            }
            return undefined;
        });
    }, [setPreviewUrl]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ActionButton, { isDisabled: busy, onPress: !busy ? onPreview : noop },
            React.createElement(Preview, null)),
        error && React.createElement(Text, null,
            "Error: ",
            error),
        React.createElement(DialogContainer, { onDismiss: onDismiss }, typeof previewUrl === 'string' && (React.createElement(PreviewRenderDialog, { url: previewUrl })))));
};
